import { ActivityMetaType, type ActivityMeta } from '@/models/Activity';

export const answerActivityMetaMap: Record<number, ActivityMeta> = {
  40020: {
    name: 'Quick Scan',
    type: ActivityMetaType.answer,
    icon: 'magnifying-glass-chart',
  },
  40021: {
    name: 'Mindset Test',
    type: ActivityMetaType.answer,
    icon: 'magnifying-glass-chart',
  },
  40022: {
    name: 'Skills Scan',
    type: ActivityMetaType.answer,
    icon: 'magnifying-glass-chart',
  },
  40023: {
    name: 'Grammar Scan',
    type: ActivityMetaType.answer,
    icon: 'magnifying-glass-chart',
  },
  40026: {
    name: 'Behavior Test',
    type: ActivityMetaType.answer,
    icon: 'trophy',
  },
  40044: {
    name: 'Word Order',
    type: ActivityMetaType.answer,
    icon: 'pen-clip',
  },
  40051: {
    name: 'Case Study',
    type: ActivityMetaType.answer,
    icon: 'pen-clip',
  },
  40052: {
    name: 'Quiz',
    type: ActivityMetaType.answer,
    icon: 'square-question',
  },
  40055: {
    name: 'Test',
    type: ActivityMetaType.answer,
    icon: 'trophy',
  },
  40058: {
    name: 'Dilemma Story',
    type: ActivityMetaType.answer,
    icon: 'pen-clip',
  },
  40070: {
    name: 'Masterclass Track',
    type: ActivityMetaType.answer,
    icon: 'chart-user',
  },
  40080: {
    name: 'Meet and Greet',
    type: ActivityMetaType.answer,
    icon: 'handshake-angle',
  },
  40090: {
    name: 'Dialog Track',
    type: ActivityMetaType.answer,
    icon: 'messages',
  },
  41000: {
    name: 'Assessment',
    type: ActivityMetaType.answer,
    icon: 'pen-clip',
  },
  42000: {
    name: 'Drive to Sell',
    type: ActivityMetaType.answer,
    icon: 'chart-user',
  },
};
